export const colors = {
  primary: '#00a5df',
  primary75: '#28c7ff',
  primary50: '#6FDAFF',
  primary25: '#B7ECFF',
  secondary: '#0D447A',
  darkSecondary: '#222D43',
  danger: '#E74C3C',
  success: '#0A9A33',
  warning: '#FDC743',
  mediumShadow: '#e0e0e0',
  darkShadow: '#b5b5b5',
  tableHeader: '#e6edf0',
  primaryBackground: '#00a5dc25',
  notConfigured: '#FDC743',
  free: '#00cf9f',
  trial: '#ff8c00',
  internal: '#000000d9',
  info: '#00c1c1',
  topHeader: '#424242',
  body: '#f5f5f5',
  navigation: '#eeeeee',
  disabledInputs: '#d1d2d9',
  primary80: '#64b6e7',
  primary60: '#95c9ee',
  primary40: '#bcdbf4',
  primary20: '#dfedfa',
  primary10: '#eff6fd',
  primary5: '#f7fbfe',
  hellBlau: '#5881c1',
  hellBlau80: '#7e98ce',
  hellBlau60: '#a0b1db',
  hellBlau40: '#c1cae8',
  hellBlau20: '#e0e4f4',
  hellBlau10: '#eef2f9',
  hellBlau5: '#f7f9fd',
  mittelBlau: '#0e447b',
  mittelBlau80: '#465f91',
  mittelBlau60: '#7481aa',
  mittelBlau40: '#a3a8c6',
  mittelBlau20: '#d1d2e3',
  mittelBlau10: '#e8e8f1',
  mittelBlau5: '#f4f4f9',
  dunkelBlau: '#222d43',
  dunkelBlau80: '#46455a',
  dunkelBlau60: '#6e687a',
  dunkelBlau40: '#9a94a1',
  dunkelBlau20: '#cac6ce',
  dunkelBlau10: '#e4e2e6',
  dunkelBlau5: '#f2f0f3',
  dachGrau: '#545454',
  dachGrau80: '#767574',
  dachGrau60: '#9d9c9c',
  dachGrau40: '#bfbfbe',
  dachGrau20: '#dddddd',
  dachGrau10: '#eeeeee',
  dachGrau5: '#f7f6f6',
  dunkelGrau: '#1e1e1c',
  dunkelGrau80: '#575247',
  dunkelGrau60: '#656160',
  dunkelGrau40: '#928e8e',
  dunkelGrau20: '#c5c2c2',
  dunkelGrau10: '#e9e9e8',
  dunkelGrau5: '#f4f3f3',
  hellOrange: '#FBBA00',
  hellOrange80: '#FDC743',
  hellOrange60: '#ffd67b',
  hellOrange40: '#ffe3ab',
  hellOrange20: '#FFF1D7',
  hellOrange10: '#fff8eb',
  hellOrange5: '#fffcf5',
  dunkelOrange: '#EB9000',
  dunkelOrange80: '#f0a742',
  dunkelOrange60: '#f5be75',
  dunkelOrange40: '#f9d4a5',
  dunkelOrange20: '#fdead3',
  dunkelOrange10: '#fef5e9',
  dunkelOrange5: '#fffaf4',
  green: '#0c9a39',
  green80: '#3bae5c',
  green60: '#6fbc84',
  green40: '#9fd0ac',
  green20: '#cfe6d5',
  green10: '#e6f2e9',
  green5: '#f3f9f5',
  red: '#e30613',
  red80: '#e94f35',
  red60: '#ef7858',
  red40: '#f6af95',
  red20: '#fcd9ca',
  red10: '#fdece5',
  red5: '#fef6f2',
  midnightBlue: '#232d41',
  midnightBlue80: '#44485b',
  midnightBlue60: '#6b6a7b',
  midnightBlue40: '#9795a2',
  midnightBlue20: '#c8c6ce',
  midnightBlue10: '#e3e2e6',
  midnightBlue5: '#f1f0f3',
  indigoBlue: '#004664',
  indigoBlue80: '#3d607c',
  indigoBlue60: '#6c8099',
  indigoBlue40: '#9ba6b8',
  indigoBlue20: '#ccd0db',
  indigoBlue10: '#e5e7ed',
  indigoBlue5: '#f2f3f6'
};
